import {Props} from './model';
import {TouchableOpacity, View, Platform} from 'react-native';
import React, {useCallback} from 'react';
import {Button} from '../../../../../shared/components/button';
import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';
import {Text} from '../../../../../shared/components/text';
import {Link} from '../../../../../shared/components/link';
import {useSelector} from 'react-redux';
import {dobroruDataLoadingSelector, dobroruDataSelector} from '../../../../../redux/selectors/dobroru';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {Screens} from '../../../../../shared/routing';
import {useNavigation} from '@react-navigation/native';
import {contentSelector} from '../../../../../redux/selectors/resources';

export default ({scrollToNestedComponent}: Props) => {
  const volunteerData = useSelector(dobroruDataSelector);
  const content = useSelector(contentSelector());
  const linkToPdf = content.services.volunteersService.scoresExchangeRulesURL;

  const loading = useSelector(dobroruDataLoadingSelector);

  const styles = useStyles(({theme, mediaOnly}) => ({
    container: mediaOnly(
      DeviceSize.desktop,
      {
        flexDirection: 'row',
        alignItems: 'stretch',
      },
      {},
    ),
    textWrapper: mediaOnly(
      DeviceSize.desktop,
      {
        flex: 1,
        paddingRight: 33,
      },
      {
        marginBottom: 20,
      },
    ),
    textBaseFont: {
      color: theme.color.labelText,
      ...mediaOnly(DeviceSize.desktop, {}, theme.fonts.bodySmallLight),
    },
    buttonWrapper: {
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          borderLeftColor: theme.color.borderColor,
          borderLeftWidth: 1,
          borderStyle: 'solid',
          flexBasis: 227,
          paddingLeft: 33,
          paddingVertical: 6,
        },
        {},
      ),
    },
    text: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.bodySmallLight},
        {
          ...theme.fonts.bodySmallLight,
        },
      ),
      color: theme.color.textColor,
    },
    link: {
      transform: [{translateY: Platform.OS === 'web' ? 0 : Platform.OS === 'ios' ? 3 : 6}],
      color: theme.color.primaryColor,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
    },
    button: {
      margin: 0,
      marginVertical: 0,
      ...mediaOnly(DeviceSize.mobile, {width: '100%'}),
      ...mediaOnly(DeviceSize.tablet, {width: 328}),
    },
    historyButton: {
      ...mediaOnly(DeviceSize.mobile, {marginTop: 30}, {marginTop: 16}),
      color: volunteerData != null ? theme.color.primaryColor : theme.color.iconGrayColor,
      fontSize: 18,
    },
  }));

  const nav = useNavigation();
  const onScoreTransferPress = useCallback(() => {
    nav.navigate(Screens.RewardShop, {tabId: 'shopWindow'});
  }, [volunteerData]);

  return (
    <View style={styles.container}>
      <View style={styles.textWrapper}>
        <Text style={styles.textBaseFont}>
          Мы благодарны за Ваш вклад в волонтерское движение! Поэтому полученные часы портала{' '}
          <Link external href='https://dobro.ru/' testID='volunteers-dobroru-href'>
            <Text style={styles.link}>Добро.рф</Text>
          </Link>{' '}
          мы перевели в баллы, которые Вы можете обменять на различную атрибутику проекта. Подробнее о правилах обмена
          баллов можно узнать на{' '}
          <Link external href={linkToPdf} testID='volunteers-dobroru-website'>
            <Text style={styles.link}>сайте</Text>
          </Link>
          .
        </Text>
      </View>

      <View style={styles.buttonWrapper}>
        {loading ? (
          <LoadableContent loading={loading} />
        ) : (
          <Button
            id='score-transfer-button'
            onPress={onScoreTransferPress}
            block={true}
            style={styles.button}
            type='primary'
            text={volunteerData && volunteerData.actualScores > 0 ? 'Обменять баллы' : 'В магазин'}
          />
        )}

        <TouchableOpacity testID='exchange-history' onPress={scrollToNestedComponent}>
          <Text style={styles.historyButton}>История операций</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};
